import { KpiType } from '../coaching-insight/insight-widget/model/kpi-type.model';

import { CardItem } from './models/card-item.model';
import { CoachingTrendData } from './models/coaching-trend-data.model';
import { MyCoachingCardGroup } from './models/my-coaching-card-group.model';

export interface CoachingCardState {
    pending: {
        reload?: boolean;
        hasData?: boolean;
    };
    cardItems?: CardItem[];
    trendDataMap?: Map<KpiType, CoachingTrendData>;
    oaSummary?: MyCoachingCardGroup[];
    selectedRows?: { [key: number]: boolean };
}

export const defaultState = (): CoachingCardState => ({
    pending: {},
    selectedRows: {},
    trendDataMap: new Map<KpiType, CoachingTrendData>(),
});
